/* Global theme behavior: mobile nav, product gallery, quantity steppers */
(function () {
  function bindNav(scope) {
    scope.querySelectorAll('[data-nav-toggle]').forEach(function (btn) {
      if (btn.dataset.bound === 'true') return;
      btn.dataset.bound = 'true';
      btn.addEventListener('click', function () {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (!panel) return;
        var open = panel.getAttribute('data-open') === 'true';
        panel.setAttribute('data-open', open ? 'false' : 'true');
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });
  }

  function bindGallery(scope) {
    scope.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      if (gallery.dataset.bound === 'true') return;
      gallery.dataset.bound = 'true';
      var main = gallery.querySelector('[data-gallery-main]');
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          if (main) { main.src = thumb.dataset.src; main.alt = thumb.dataset.alt || main.alt; }
          gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
            t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
          });
        });
      });
    });
  }

  function bindQty(scope) {
    scope.querySelectorAll('[data-qty]').forEach(function (wrap) {
      if (wrap.dataset.bound === 'true') return;
      wrap.dataset.bound = 'true';
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('[data-qty-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.dataset.qtyStep, 10) || 1;
          var next = Math.max(0, (parseInt(input.value, 10) || 0) + step);
          input.value = next;
          if (wrap.dataset.qty === 'cart') input.form && input.form.submit();
        });
      });
    });
  }

  function bindVariants(scope) {
    scope.querySelectorAll('[data-variant-form]').forEach(function (form) {
      if (form.dataset.bound === 'true') return;
      form.dataset.bound = 'true';
      form.addEventListener('change', function () {
        var picked = Array.prototype.map.call(form.querySelectorAll('[data-option-index]'), function (s) { return s.value; });
        var variants = JSON.parse(form.querySelector('[data-variant-json]').textContent);
        var match = variants.find(function (v) {
          return v.options.every(function (o, i) { return o === picked[i]; });
        });
        var idField = form.querySelector('[name="id"]');
        var priceEl = document.querySelector('[data-variant-price]');
        if (match) {
          if (idField) idField.value = match.id;
          if (priceEl && match.price_formatted) priceEl.textContent = match.price_formatted;
        }
      });
    });
  }

  function initAll(scope) {
    scope = scope || document;
    bindNav(scope); bindGallery(scope); bindQty(scope); bindVariants(scope);
  }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
